import type { PushlySdk } from '../types/pushly-sdk'
import { injectExternalScript } from '../hooks/use-external-script'
import aqe from '@pushly/aqe'

const sdkSelector = 'script[src*="/pushly-sdk.min.js"]'

/**
 * Starts the Pushly SDK for a domain key. The page holds one SDK script and makes one `load` call
 * per key, however often this runs (a retried platform load calls it again). A repeat for the key
 * already running is a no-op. A different key replaces the script: a failed attempt can only use the
 * default key, and a later success may name the key of a preview whitelabel, which must win.
 */
export const injectPushlySdk = (domainKey: string) => {
    const src = `${aqe.defaults.publicCdnDomain}/pushly-sdk.min.js?domain_key=${domainKey}`
    const existing = Array.from(document.querySelectorAll<HTMLScriptElement>(sdkSelector))
    if (existing.some((script) => script.getAttribute('src') === src)) {
        return
    }
    existing.forEach((script) => script.remove())

    window.PlatformNotifications = {
        supported: true,
    }

    window.PushlySDK = window.PushlySDK || []
    window.pushly = function () {
        window.PushlySDK!.push(arguments)
    }

    injectExternalScript({
        src,
        async: true,
    })

    window.pushly('on_web_push_unsupported', () => {
        window.PlatformNotifications!.supported = false
    })

    window.pushly('load', { domainKey })
}

export const getPushlySdk = (): PushlySdk | undefined => {
    return Array.isArray(window.PushlySDK) ? undefined : window.PushlySDK
}
